import PropTypes from "prop-types";
import React from "react";
import { Button, Link } from "@xo-union/tk-component-buttons";
import Icon from "@xo-union/tk-component-icons";
import styles from "./styles.css";
import SharedBanner from "../shared/banner/index.js";
export default function BannerWidget(_ref) {
  var headline = _ref.headline,
    buttonText = _ref.buttonText,
    href = _ref.href,
    handleClose = _ref.handleClose,
    animation = _ref.animation,
    isVisibile = _ref.isVisibile;
  if (!isVisibile) {
    return null;
  }
  return /*#__PURE__*/React.createElement(SharedBanner, {
    animation: animation,
    dataTestId: "stylematch-quiz-banner",
    isVisibile: isVisibile
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.leftSide
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.headline,
    "data-testid": "headline-container"
  }, headline), /*#__PURE__*/React.createElement("div", {
    className: styles.action
  }, /*#__PURE__*/React.createElement(Link, {
    color: "primary",
    size: "sm",
    href: href
  }, buttonText))), /*#__PURE__*/React.createElement("div", {
    className: styles.badges
  }, /*#__PURE__*/React.createElement("img", {
    className: styles['badge-image'],
    src: window.innerWidth < 768 ? 'https://media-api.xogrp.com/images/ffe6ed59-f312-49a2-868c-e1f79cc85f76' : 'https://qa-media-api.xogrp.com/images/6a83adda-3833-44b2-8b53-24c2c974e6f3',
    alt: "Badges"
  })), /*#__PURE__*/React.createElement(Button, {
    color: "tertiary-alternative",
    size: "md",
    role: "button",
    className: styles.closeButton,
    onClick: handleClose,
    "data-testid": "close-button"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    size: "md",
    className: styles['close-icon']
  })));
}
process.env.NODE_ENV !== "production" ? BannerWidget.propTypes = {
  headline: PropTypes.string,
  buttonText: PropTypes.string,
  href: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  animation: PropTypes.string.isRequired,
  isVisibile: PropTypes.bool.isRequired
} : void 0;
BannerWidget.defaultProps = {
  headline: 'Find dresses in your style and budget',
  buttonText: 'Take the quiz',
  href: '/stylematch-wedding-dress-quiz?user_decision_area=fashion-banner'
};